import { render } from "./ProjectSummaryProgress.vue?vue&type=template&id=3d4572ca"
import script from "./ProjectSummaryProgress.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__